const apiUrl = process.env.REACT_APP_API_URL;

export const ClaimCazaReward = async (idCaza: number, userId: string, idConjunt?: number | null, selectedRewardId?: number | null) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${idCaza}/claim`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    id: userId, 
                    idConjunt: idConjunt ?? null,
                    selectedRewardId: selectedRewardId ?? null
                }) // UserId object expected
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error claiming reward:', error);
        return null;
    }
};
